module.exports = __webpack_public_path__ + "img/pic12.0ee6ef67.png";